import { z } from 'zod';

export const OBJECT_STORAGE_IMAGE_CONTENT_TYPES = [
  'image/jpeg',
  'image/png',
  'image/webp',
  'image/gif',
] as const;

export const OBJECT_STORAGE_VIDEO_CONTENT_TYPES = ['video/mp4'] as const;

export const OBJECT_STORAGE_CERTIFICATE_CONTENT_TYPES = [
  'application/x-pkcs12',
  'application/octet-stream',
] as const;

export const OBJECT_STORAGE_CONTENT_TYPES = [
  ...OBJECT_STORAGE_IMAGE_CONTENT_TYPES,
  ...OBJECT_STORAGE_VIDEO_CONTENT_TYPES,
  ...OBJECT_STORAGE_CERTIFICATE_CONTENT_TYPES,
] as const;

export const PresignUploadBodySchema = z.object({
  purpose: z
    .string()
    .trim()
    .min(1)
    .max(48)
    .regex(/^[a-z][a-z0-9-]{0,47}$/),
  contentType: z.enum(OBJECT_STORAGE_CONTENT_TYPES),
  contentLength: z.number().int().positive(),
});

export type PresignUploadBody = z.infer<typeof PresignUploadBodySchema>;

export const PresignUploadResponseSchema = z.object({
  uploadUrl: z.url(),
  storageKey: z.string().min(1),
  expiresAt: z.iso.datetime(),
});

export type PresignUploadResponse = z.infer<typeof PresignUploadResponseSchema>;
